export const DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const SHIFT_TYPES = [
  { value: 'shift', label: 'Shift', chip: 'bg-cyan-100 text-cyan-800 border-cyan-200', dot: 'bg-cyan-500' },
  { value: 'on_call', label: 'On-call', chip: 'bg-amber-100 text-amber-800 border-amber-200', dot: 'bg-amber-500' },
  { value: 'remote', label: 'Remote', chip: 'bg-emerald-100 text-emerald-800 border-emerald-200', dot: 'bg-emerald-500' },
];

export const typeMeta = (t) => SHIFT_TYPES.find((s) => s.value === t) || SHIFT_TYPES[0];

export const toISODate = (d) => {
  const x = new Date(d);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`;
};

// Monday of the week containing `d`
export const startOfWeek = (d = new Date()) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  const dow = (x.getDay() + 6) % 7;
  x.setDate(x.getDate() - dow);
  return x;
};

export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};

export const weekDays = (monday) => Array.from({ length: 7 }, (_, i) => addDays(monday, i));

export const weekLabel = (monday) => {
  const sun = addDays(monday, 6);
  const f = (d, o) => d.toLocaleDateString([], o);
  return `${f(monday, { month: 'short', day: 'numeric' })} – ${f(sun, { month: 'short', day: 'numeric', year: 'numeric' })}`;
};

export const fmtTime = (hhmm) => {
  if (!hhmm) return '';
  const [h, m] = hhmm.split(':').map(Number);
  const ampm = h >= 12 ? 'pm' : 'am';
  const hh = h % 12 === 0 ? 12 : h % 12;
  return m ? `${hh}:${String(m).padStart(2, '0')}${ampm}` : `${hh}${ampm}`;
};

export const shiftHours = (s) => {
  const [sh, sm] = s.start_time.split(':').map(Number);
  const [eh, em] = s.end_time.split(':').map(Number);
  let mins = eh * 60 + em - (sh * 60 + sm);
  if (mins <= 0) mins += 24 * 60;
  return mins / 60;
};
